import React, { useEffect, useState, useRef } from "react";
//import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import IconDescription from "@mui/icons-material/DescriptionOutlined";
import IconClock from "@mui/icons-material/AccessTimeOutlined";
import { fechaBase, openLink } from "../Script/script";
import Review from "../Review/review";
import { obtenerCursoDetalle } from "../Services/cursosServices";
import { Avatar, Box, Paper } from "@mui/material";
import { Bloodtype } from "@mui/icons-material";

const useStyles = makeStyles({
  root: {
    //float: "left",
    width: "100%",
    margin: "auto",
  },

  media: {
    height: "200px",
  },
});
const Curso = ({ curso }) => {
  const [detalle, setDetalle] = useState({});

  useEffect(() => {
    obtenerDetalle();
  }, [curso.idUdemy]);

  const obtenerDetalle = async () => {
    const { data: detalle } = await obtenerCursoDetalle(curso.idUdemy);
    setDetalle({ precio: detalle.price });
  };

  const classes = useStyles();

  let hoy = new Date();

  return (
    <>
      <Grid item xs={12} sm={4} lg={4}>
        <Card className={classes.root} sx={{ boxShadow: 10, height: "100%" }}>
          <CardActionArea>
            <CardMedia component="img" height="240" image={curso.imagen} />

            <CardContent>
              <Typography
                gutterBottom
                variant="h5"
                component="div"
                style={{ textAlign: "left" }}
              >
                {curso.titulo}
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                style={{ textAlign: "left" }}
              >
                {curso.descripcion.substring(0, 150) + "..."}
              </Typography>
            </CardContent>
            <hr />
            <CardContent>
              <Grid container>
                <Grid item xs={4}>
                  <Typography variant="body2" color="text.secondary">
                    <IconDescription
                      fontSize="small"
                      style={{ verticalAlign: "middle" }}
                    />{" "}
                    {curso.secciones} Módulos
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2" color="text.secondary">
                    <IconClock
                      fontSize="small"
                      style={{ verticalAlign: "middle" }}
                    />{" "}
                    {curso.duracion}
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="body2">
                    <span
                      style={{
                        //fontWeight: "bold",
                        color: "#FFF",
                        backgroundColor: "#1cc31c",
                        padding: "4px",
                      }}
                    >
                      {curso.precio ? curso.precio + " US$" : "Gratuito"}
                    </span>
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
            <CardActions>
              <Button
                target="_blank"
                variant="outlined"
                color="secondary"
                href={
                  fechaBase(curso.vencimiento, "YYYYMMDD") >
                  fechaBase(hoy, "YYYYMMDD")
                    ? curso.url + "?couponCode=" + curso.cupon
                    : curso.url + "?referralCode=" + curso.refCode
                }
                size="small"
              >
                saber más
              </Button>
            </CardActions>
          </CardActionArea>
        </Card>

        {1 == 2 && (
          <>
            <CardActionArea
              target="_blank"
              href={
                fechaBase(curso.vencimiento, "YYYYMMDD") >
                fechaBase(hoy, "YYYYMMDD")
                  ? curso.url + "?couponCode=" + curso.cupon
                  : curso.url + "?referralCode=" + curso.refCode
              }
            >
              <Box sx={{ position: "relative" }}>
                <CardMedia
                  style={{ height: "500px" }}
                  //className={classes.media}
                  image={curso.imagen}
                  //title={curso.titulo}
                />
                <Box
                  sx={{
                    position: "absolute",
                    bottom: 0,
                    right: 0,
                    bgcolor: "rgba(255, 255, 255, 0.20)",
                    padding: "7px",
                  }}
                >
                  <Avatar
                    sx={{
                      width: 50,
                      height: 50,
                    }}
                    src="images/udemy_small.png"
                  />
                </Box>
              </Box>
            </CardActionArea>

            <Card className={classes.root} variant="outlined">
              <CardActionArea>
                <CardContent>
                  <Typography gutterBottom variant="h4" component="h2">
                    {curso.titulo}
                  </Typography>
                  <Typography
                    variant="body1"
                    color="textSecondary"
                    component="span"
                  >
                    {curso.descripcion}
                  </Typography>
                </CardContent>
              </CardActionArea>
              <Typography
                variant="body1"
                color="textSecondary"
                component="span"
              >
                <b>Duración:</b>&nbsp;
                {curso.duracion}
              </Typography>
              <br />
              <Typography
                variant="body1"
                color="textSecondary"
                component="span"
              >
                <b>Modalidad:</b> Clases Online
              </Typography>
              <br />
              {curso.precio !== 0 && (
                <div>
                  <Typography variant="body1" gutterBottom component="span">
                    Precio anterior{" "}
                    <strike style={{ color: "red" }}>{detalle.precio}</strike>
                    <br />
                    <b>Precio con descuento</b>{" "}
                    <Typography
                      gutterBottom
                      variant="h4"
                      component="h2"
                      color="green"
                    >
                      9.99 US$
                    </Typography>
                  </Typography>
                </div>
              )}
              <Button
                target="_blank"
                href={
                  fechaBase(curso.vencimiento, "YYYYMMDD") >
                  fechaBase(hoy, "YYYYMMDD")
                    ? curso.url + "?couponCode=" + curso.cupon
                    : curso.url + "?referralCode=" + curso.refCode
                }
                variant="contained"
                size="medium"
                color={curso.precio === 0 ? "success" : "warning"}
              >
                {curso.precio === 0
                  ? "inscríbete ahora gratis"
                  : "cupón con descuento"}
              </Button>
              <CardActions></CardActions>
              <hr />
              <Review idUdemy={curso.idUdemy} titulo={curso.titulo}></Review>
            </Card>
          </>
        )}
      </Grid>
    </>
  );
};

export default Curso;
